module.exports = __webpack_public_path__ + "static/media/carpet.0854f8f1.svg";